/** Builder section types of the `postPurchase` templates. No imports: `entities/LandingPage` reads it. */
export const postPurchaseSectionTypes = [
  "ppHeading",
  "ppProgress",
  "ppText",
  "ppBox",
  "ppOfferCard",
  "ppCardGrid",
  "ppSplitChecklist",
  "ppChecklist",
  "ppComparison",
  "ppStats",
  "ppPriceBox",
  "ppTestimonials",
  "ppCountdownBox",
  "ppDivider",
  "ppOfferForm",
] as const;
